import { get, set } from 'idb-keyval';
import { cookieBannerFunct } from './cookiebanner';

function refreshMobileHeighMenu(){
	const head = document.querySelector('.ocw-top-bar');
	const menuCont = document.querySelector('.menu-cont');
	const bounds = head.getBoundingClientRect();
	
	if(menuCont){
		menuCont.style.setProperty('--dialog-top', `${bounds.bottom + 1}px`);
		menuCont.style.setProperty('--dialog-height', `${(window.innerHeight * 1.3) - (bounds.bottom + 1)}px`);
	}
}

function getOS() {
	const { userAgent } = window.navigator;
	const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (/Linux/.test(platform)) {
		os = 'Linux';
	}

	return os;
}

function hideElementsWhenActive(){
	if(document.querySelector('.ocw-top-bar').classList.contains("is-active")){
		document.querySelector('.cookiebanner').style.display = `none`;
    	if(document.querySelector('.five9.chat-box')){
      		document.querySelector('.five9.chat-box').style.display = `none`;
    	}
		if(document.querySelector('.location-button')){
			document.querySelector('.location-button').style.display = `none`;
		}

	}
	else{
		if(document.querySelector('.five9.chat-box')){
			document.querySelector('.five9.chat-box').style.display = `block`;
		}
		if(document.querySelector('.location-button')){
			document.querySelector('.location-button').style.display = `block`;
		}
		cookieBannerFunct();
	}

}
export function navmenu(){

	// Toggle to show and hide navbar menu
	const navbarMenu = document.querySelector(".nav");
	const burgerMenu = document.querySelector(".hamburger");
	const menuContainer = document.querySelector('.menu-cont');
	const os = getOS();
	const getAppMsg = ((document.documentElement.lang === 'en-US') ? 'Get app' : 'Obtén el app');
	const downloadClassName = (os === 'Android' || os === 'iOS' ? os : 'other').toLowerCase();
	const getAppContent = document.querySelector('.download.appstore');
	let top ='';
	let state = '';
	let position = {
		x: 0,
		y: 0,
	};
	if(document.querySelector('.banner .close')){
		document.querySelector('.banner .close').addEventListener('click', () =>{
			document.querySelector('.banner').remove();
			refreshMobileHeighMenu();
			
			set('prefs-hide-banner', JSON.stringify({ show: 'banner', time: Date.now() }));
		});
	}else{
		document.querySelector('.menu-cont').style.setProperty('--dialog-top', `auto`);
	}
	
	//Add aria attributes for WCGAG compliance
	const menuGroups = document.querySelectorAll("nav div.sub-menu-container a");
	menuGroups.forEach( (item) => {
		item.setAttribute("role", "menuitem");
	});

	getAppContent.classList.add(downloadClassName);
	if(downloadClassName != 'other'){
		if(os === 'Android'){
			getAppContent.innerHTML = `<span><a href="https://app.oportun.com/download"  target="_blank" data-event_tracking="button click" data-event_tracking_label="Get app"  data-event_tracking_section="Header"><oportun-graphic name="playstore-logo-mark" />${getAppMsg}</a></span>`;
		}
		if(os === 'iOS'){
			getAppContent.innerHTML = `<span><a href="https://app.oportun.com/download"  target="_blank" data-event_tracking="button click" data-event_tracking_label="Get app"  data-event_tracking_section="Header"><oportun-graphic name="appstore-logo" />${getAppMsg}</a></span>`;
		}
	} else{
		getAppContent.innerHTML = `<span><a href="https://app.oportun.com/download"  target="_blank" data-event_tracking="button click" data-event_tracking_label="Get app"  data-event_tracking_section="Header">${getAppMsg}</a></span>`;
	}

	burgerMenu.addEventListener("click", () => {
		if(navbarMenu){
			navbarMenu.classList.toggle("is-active");
		}
		burgerMenu.classList.toggle("is-active");
		menuContainer.classList.toggle("is-active");
		document.querySelector('.ocw-top-bar').classList.toggle('is-active');
		document.querySelector('.ocw-navbar').classList.toggle('is-active');
		document.querySelector('body').classList.toggle('scroll-lock');
		hideElementsWhenActive();
    if(document.querySelector('.ocw-top-bar').classList.contains("scroll-show")){
      document.querySelector('.ocw-top-bar').classList.remove("scroll-show")
    }
	});

	// Function to display the dropdown menu
	const toggleDropdownItem = (item) => {
		const head = document.querySelector('.ocw-top-bar');
		const bounds = head.getBoundingClientRect();
		const menuCont = document.querySelector('.menu-cont');
		const dropdownContent = item.querySelector(".sub-menu");
		// Remove other dropdown that have 'dropdown-show' class
		if (item.classList.contains("dropdown-show")) {
			dropdownContent.removeAttribute("style");
			item.classList.remove("dropdown-show");
		} else {
			// Added max-height on active 'dropdown-show' class
			dropdownContent.style.height = `${dropdownContent.scrollHeight}px`;
			menuCont.style.setProperty('--dialog-height', `${(window.innerHeight * 1.3 + dropdownContent.scrollHeight) - (bounds.bottom + 1)}px`);
			item.classList.add("dropdown-show");
		}
	};
	// Toggle to show and hide dropdown menu
	const dropdown = document.querySelectorAll(".menu-item-has-children");

	dropdown.forEach((item) => {
		const dropdownToggle = item.querySelector("a");
		
		dropdownToggle.addEventListener("click", (e) => {
			if (window.innerWidth <= 1070) {
				e.preventDefault();
			}
			const dropdownShow = document.querySelector(".dropdown-show");
			toggleDropdownItem(item);
			// Remove 'dropdown-show' class from other dropdown<
			if (dropdownShow && dropdownShow != item) {
				toggleDropdownItem(dropdownShow);
			}
		});
	});

	window.addEventListener('load', () =>  {
		get('prefs-hide-banner').then((val) => {
			if (val !== undefined) {
				try {
					const data = JSON.parse(val);
					const oneDay = 1 * 60 * 60 * 1000;
					if (data.time && Date.now() - data.time < oneDay) {
						document.querySelector('.banner').remove();
            document.querySelector('.menu-cont').style.setProperty('--dialog-top', `auto`);
					}
				} catch (e) {}
			}
		});
		if (window.innerWidth <= 1070) {
			const dropdownItems = document.querySelectorAll(".menu-item-has-children");
			dropdownItems.forEach((item) => {
				item.classList.toggle("mobile");
			});
			refreshMobileHeighMenu();
			hideElementsWhenActive();
		}
	});

	// Fixed dropdown menu on window resizing
	window.addEventListener("resize", () => {
		if (window.innerWidth <= 1070) {
			if(document.querySelector('.ocw-top-bar').classList.contains("is-active")){
				if(navbarMenu){
					navbarMenu.classList.toggle("is-active");
				}
				burgerMenu.classList.toggle("is-active");
				menuContainer.classList.toggle("is-active");
				document.querySelector('.ocw-top-bar').classList.toggle('is-active');
		
				const dropdownItems = document.querySelectorAll(".menu-item-has-children");
				dropdownItems.forEach((item) => {
					item.classList.toggle("mobile");
				});
			}
			hideElementsWhenActive();
			refreshMobileHeighMenu();
			document.querySelectorAll(".nav").forEach((item) => {
				item.removeAttribute("style");
			});

		}
	});

	const handleScroll = (e) => {
		const { scrollHeight, clientHeight, scrollTop } = document.documentElement;
		
		let progress = (scrollTop / (scrollHeight - clientHeight)) * 100;
		const dir = scrollTop > position.y ? 1 : 0;
  		
		position.y = Math.abs(scrollTop);
		progress = progress;
		if (progress < 1) {
		  top  = true;
		} else {
		  top = false;
		}
  
		if (dir === 1) {
      document.querySelector('.ocw-top-bar').classList.remove('scroll-show');
		} else {
      if(!document.querySelector('.ocw-top-bar').classList.contains("scroll-show")){
        document.querySelector('.ocw-top-bar').classList.add('scroll-show');
      }
      else{
        if(progress === 0)
          {
            document.querySelector('.ocw-top-bar').classList.remove('scroll-show');
          }
      }
		}
	  };
  
	  window.addEventListener('scroll', handleScroll, { passive: true });

	//Make changes to language toggle
	let url = window.location.href;
	const langToggles = document.querySelectorAll('.langselector a');

	//Remove lanauge toggle from News Archive page.
	if(url.endsWith("/news/")){
		langToggles.forEach( (el) => {
			el.remove();
		});
	}else{
		//Make language toggle work on new spanish locations pages
		if(url.includes('/es/sucursales')){
			url = url.replace('/es/sucursales', '/locations').replace('estado', 'state');
		}else if(url.includes('/locations')){
			url = url.replace('/locations', '/es/sucursales').replace('state', 'estado');
		}else{
			url = "";
		}
	
		if(url != ""){
			langToggles.forEach( (el) => {
				el.href = url;
			});
		}
	}
}

